import { minutesInHour } from 'helpers/timeConsts';
import { TFunction } from 'react-i18next';

export default function getDurationFormat(
  minutesDuration: number,
  t: TFunction,
) {
  const hours = Math.floor(minutesDuration / minutesInHour);
  const minutes = minutesDuration % minutesInHour;

  if (minutes === 0) {
    return t('project_tracking.hours_duration', { hours });
  }

  if (hours === 0) {
    return t('project_tracking.minutes_duration', { minutes });
  }

  return t('project_tracking.hours_minutes_duration', { hours, minutes });
}
